import React, { useEffect, useState, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import { navLinks } from "../../shared/constants/navMenu";
import "./Header.scss";

export default function Header() {
  const [isSticky, setIsSticky] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [navExpanded, setNavExpanded] = useState(false);
  const navRef = useRef(null);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsSticky(window.scrollY > 100);
    };

    const handleClickOutside = (event) => {
      if (navRef.current && !navRef.current.contains(event.target)) {
        setActiveDropdown(null);
        setNavExpanded(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      window.removeEventListener("scroll", handleScroll);
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleDropdownToggle = (index) => {
    setActiveDropdown(activeDropdown === index ? null : index);
  };

  const handleNavToggle = () => {
    setNavExpanded(!navExpanded);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      {location.pathname === "/" && (
        <header className="site-header">
          <div className="container">
            <div className="row">
              <div className="col-lg-8 col-12 d-flex flex-wrap header-address-custom">
                <p className="d-flex mb-0 pointer">
                  <i className="bi-envelope me-2"></i>
                  <a href="mailto:info@dohrniiexim.com">
                    info@dohrniiexim.com
                  </a>
                </p>
              </div>
              <div className="col-lg-3 col-12 ms-auto d-lg-block d-none">
                <ul className="social-icon">
                  {[
                    {
                      name: "whatsapp",
                      link: "https://wa.me/+919967306099?text=Hello%2C%20I%20want%20to%20know%20more%20information%20about%20Dohrnii%20Exim!",
                    },
                  ].map(({ name, link }) => (
                    <li key={name} className="social-icon-item">
                      <a
                        href={link}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={`social-icon-link bi-${name}`}
                        aria-label={
                          name.charAt(0).toUpperCase() + name.slice(1)
                        }
                      ></a>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </header>
      )}

      <nav
        ref={navRef}
        className={`navbar navbar-expand-lg bg-light shadow-lg ${isSticky ? "sticky-nav" : ""
          }`}
      >
        <div className="container">
          <Link to="/">
            <img
              src={`${process.env.PUBLIC_URL}/assets/img/logo.png`}
              className="img-fluid logo"
              alt="Logo"
             />
          </Link>

          <button
            className="navbar-toggler"
            type="button"
            aria-controls="navbarNav"
            aria-expanded={navExpanded}
            aria-label="Toggle navigation"
            onClick={handleNavToggle}
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <div
            className={`collapse navbar-collapse ${navExpanded ? "show" : ""}`}
            id="navbarNav"
          >
            <ul className="navbar-nav ms-auto">
              {navLinks.map((link, index) => (
                <li
                  key={index}
                  className={`nav-item ${link.subMenu ? "dropdown" : ""}`}
                >
                  {link.subMenu ? (
                    <>
                      <span
                        className={`nav-link dropdown-toggle ${activeDropdown === index ? "show" : ""
                          }`}
                        id={`navbarDropdown${index}`}
                        role="button"
                        aria-expanded={activeDropdown === index}
                        onClick={() => handleDropdownToggle(index)}
                      >
                        {link.name}
                      </span>
                      <ul
                        className={`dropdown-menu dropdown-menu-light ${activeDropdown === index ? "show" : ""
                          }`}
                        aria-labelledby={`navbarDropdown${index}`}
                      >
                        {link.subMenu.map((subLink, subIndex) => (
                          <li key={subIndex}>
                            <Link
                              className="dropdown-item"
                              to={subLink.path}
                              onClick={() => {
                                setActiveDropdown(null);
                                setNavExpanded(false);
                              }}
                            >
                              {subLink.name}
                            </Link>
                          </li>
                        ))}
                      </ul>
                    </>
                  ) : (
                    <Link
                      className="nav-link click-scroll"
                      to={link.path}
                      onClick={() => setNavExpanded(false)}
                    >
                      {link.name}
                    </Link>
                  )}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
}
